import React, { Component } from 'react';
import Table from '../components/health/RelatedEvent/Table'
import WebpackerReact from 'webpacker-react';

class RelatedEventIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: false,
            showbtnSubmit: false,
            formFilter: {
                name: ""
            },
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 


    handleClickFilter = () => {
        fetch(`/health/get_related_events?name=${this.state.formFilter.name}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                data: data.data,
                showbtnSubmit: true,
            });
        });
    };

    clearValues = () => {
        this.setState({
            formFilter: {
                name: ""
            },
            showbtnSubmit: false,
        })
        
        this.loadData();
    }

    handleChangeFilter = e => {
        this.setState({
            formFilter: {
                ...this.state.formFilter,
                [e.target.name]: e.target.value
            }
        });
    };

    loadData = () => {
        fetch("/health/get_related_events", {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: true
          });
        });
    }

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = area => {
        this.setState({
            data: this.state.data.map(item => {
            if (area.id === item.id) {
              return { ...item, 
                name: area.name,
                module: area.module,
              }
            }
            return item;
          })
        });
    }


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    estados={this.props.estados}

                    //update real 
                    updateItem={this.updateItem}
                    updateData={this.updateData}

                    //filter
                    handleClickFilter={this.handleClickFilter}
                    handleChangeFilter={this.handleChangeFilter}
                    showbtnSubmit={this.state.showbtnSubmit}
                    formFilter={this.state.formFilter}
                    clearValues={this.clearValues}
                />
            </React.Fragment>
        );
    }
}


export default RelatedEventIndex;
WebpackerReact.setup({ RelatedEventIndex });
